import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export function bindAll(fns, context) {
  fns.forEach(function (fn) {
    if (!context[fn]) {
      return;
    }
    context[fn] = context[fn].bind(context);
  });
}

// 频率控制器
export var FrequencyController = /*#__PURE__*/function () {
  function FrequencyController() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    _classCallCheck(this, FrequencyController);
    _defineProperty(this, "duration", 16);
    _defineProperty(this, "timestamp", new Date().getTime());
    this.duration = duration;
  }
  _createClass(FrequencyController, [{
    key: "run",
    value: function run(callback) {
      var currentTime = new Date().getTime();
      var timeCut = currentTime - this.timestamp;
      this.timestamp = currentTime;
      if (timeCut >= this.duration) {
        callback();
      }
    }
  }]);
  return FrequencyController;
}();